<template>
    <div>
        <ul>
            <li
            v-for="product in products"
            :key="product.id">
            {{ product.title }}
            <br>
                <button
                    @click="addProductToCart(product)">
                    Add to cart
                </button>
            </li>
        </ul>

        <Cart />


    </div>
</template>

<script>
import Cart from '../components/Cart'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            products: [
                {"id": 5, "title": "Toilet paper", "quantity": 1},
                {"id": 7, "title": "Sausage", "quantity": 1},
                {"id": 9, "title": "Britney spears CD", "quantity": 1}
            ]
        }
    },
    methods: mapActions('cart', [
        'addProductToCart'
    ]),
    components: {Cart}
}
</script>